<tgrid-layer-header [layer]="this" [additionIcons]="iconConfig()">

  <div class="legend">

    @for (item of colors; track $index) {
      <div class="legend-label">
        <div class="color-circle" [style.background-color]="item.color"></div>
        <span>{{ item.category }}</span>
      </div>
    }
    <div class="legend-label">
      <div class="color-circle" [style.background-color]="'#444444'"></div>
      <span>Not Covered</span>
    </div>

  </div>
</tgrid-layer-header>
